export const accountResources = {
  'account.yourAccountSettings': '您的帐户设置',
  'account.firstName': '名字',
  'account.lastName': '姓',
  'account.email': '电子邮件',
  'account.role': '角色',
  'account.resetPassword': '重设密码',
  'account.editInfo': '编辑资讯',
  'account.resetPasswordConfirmation': '您确定要重设密码吗？',
  // TODO(EURO-23): replace with compliance-approved Chinese copy.
  'account.login.privacyBanner.title': 'We Value Your Privacy',
  'account.login.privacyBanner.body':
    'We use essential cookies to ensure basic site functionality and enhance platform security. By continuing to log in to this site, you consent to our use of cookies and acknowledge our {privacyPolicy}, which outlines our data privacy practices and cookie usage.',
  'account.login.privacyBanner.privacyPolicy': 'Privacy Policy',
};

export type AccountResourceKey =
  | 'account.yourAccountSettings'
  | 'account.firstName'
  | 'account.lastName'
  | 'account.email'
  | 'account.role'
  | 'account.resetPassword'
  | 'account.editInfo'
  | 'account.resetPasswordConfirmation'
  | 'account.login.privacyBanner.title'
  | 'account.login.privacyBanner.body'
  | 'account.login.privacyBanner.privacyPolicy';
